<template>

<app-view-sheet-field align="center" :is-sticky="isSticky" :field="field" :filter="filter">

	{{ value }}

</app-view-sheet-field>

</template>

<script>

export default {

	props: ['field', 'filter', 'item', 'isSticky'],

    computed: {

		value: function() {

            var score = this.item.users.divisiveness

			if (score === 0 && this.count < 2) return 'n/a'
			if (score <= 0.4) return 'Very Low'
			if (score <= 0.8) return 'Low'
			if (score <= 1.2) return 'Medium'
			if (score <= 1.6) return 'High'
			if (score > 1.6) return 'Very High'

			return false

		}

    }

}

</script>

<style scoped>

</style>